import { portalJson } from '../lib/portalApi';
import { getPortalToken } from '../lib/portalSession';

export type HistoryRow = {
  source: 'consult' | 'product' | 'qna';
  id: number;
  category: string;
  title: string;
  status: string;
  createdAt: string | null;
  _sort: number;
};

type ConsultRow = { id: number; type: string; title: string; status: string; createdAt: string | null };
type ProductRow = { id: number; type: string; title: string; status: string; createdAt: string | null };
type QnaRow = { id: number; type: string; title: string; status: string; createdAt: string | null };

function parseDotDate(s: string | null | undefined): number {
  if (!s) return 0;
  const parts = s.split('.').map((x) => parseInt(x, 10));
  if (!parts[0]) return 0;
  const y = parts[0];
  const m = parts[1] ?? 1;
  const d = parts[2] ?? 1;
  return new Date(y, m - 1, d).getTime();
}

/** 병합 신청내역 — 기존 /api/me/* 만 사용 */
export async function fetchMyApplicationHistory(): Promise<HistoryRow[]> {
  if (!getPortalToken()) {
    throw new Error('로그인이 필요합니다.');
  }

  const [c1, c2, c3] = await Promise.all([
    portalJson<ConsultRow[]>('/api/me/consult-applications', { auth: true }),
    portalJson<ProductRow[]>('/api/me/product-applications', { auth: true }),
    portalJson<QnaRow[]>('/api/me/qna-tickets', { auth: true }),
  ]);

  if (!c1.ok) throw new Error(c1.message);
  if (!c2.ok) throw new Error(c2.message);
  if (!c3.ok) throw new Error(c3.message);

  const consults = c1.data;
  const products = c2.data;
  const qnas = c3.data;

  const rows: HistoryRow[] = [];

  for (const r of consults) {
    rows.push({
      source: 'consult',
      id: r.id,
      category: r.type || '상담',
      title: r.title || '상담신청',
      status: r.status,
      createdAt: r.createdAt,
      _sort: parseDotDate(r.createdAt),
    });
  }
  for (const r of products) {
    rows.push({
      source: 'product',
      id: r.id,
      category: r.type || '제품',
      title: r.title || '제품신청',
      status: r.status,
      createdAt: r.createdAt,
      _sort: parseDotDate(r.createdAt),
    });
  }
  for (const r of qnas) {
    rows.push({
      source: 'qna',
      id: r.id,
      category: r.type || '문의',
      title: r.title || 'Q&A',
      status: r.status,
      createdAt: r.createdAt,
      _sort: parseDotDate(r.createdAt),
    });
  }

  rows.sort((a, b) => b._sort - a._sort);
  return rows;
}
